@if (!multiple) {
    <div
        class="dropdown-container relative mt-6 rounded-t-md"
        [ngClass]="{
            'border-t-red-600 border-r-red-600 border-l-red-600 border': showError && !option()
        }"
    >
        <p-select
            #dropdown
            [id]="id"
            (onHide)="showPanel = false"
            (onShow)="showPanel = true"
            [options]="sortedOptions"
            [(ngModel)]="option"
            [showClear]="limpiar"
            [optionLabel]="propiedad"
            appendTo="body"
            [filter]="filtrar"
            filterPlaceholder="Ingrese búsqueda"
            [resetFilterOnHide]="true"
            [readonly]="readonly"
            class="h-12 w-full"
        >
            <ng-template pTemplate="dropdownicon">
                @if (!readonly) {
                    <img
                        src="assets/svg/arrow.svg"
                        alt="Arrow"
                        width="20"
                        [ngClass]="{ 'rotate-90': showPanel, '-rotate-90': !showPanel }"
                        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer transition-all duration-200 pointer-events-none"
                    />
                }
            </ng-template>
            <ng-template pTemplate="clearicon">
                <svg width="28" height="28" viewBox="0 0 24 24">
                    <path d="M14.5 9.5 9.5 14.5M9.5 9.5 14.5 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </ng-template>
            @if (descripcionLabel) {
                <ng-template let-item pTemplate="item">
                    <p class="font-bold truncate max-w-[140px]">{{ propiedad ? (item[propiedad] ?? item) : item }}</p>
                    @if (item[descripcionLabel]) {
                        <small class="pl-2">{{ item[descripcionLabel] }}</small>
                    }
                </ng-template>
            }
        </p-select>
        <label class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none" [ngClass]="{ 'label-active': showPanel || option() }">
            {{ etiqueta }}
        </label>
        <label
            class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none"
            [ngClass]="{
                'opacity-100': showPanel && !option(),
                'opacity-0': !showPanel || option()
            }"
        >
            {{ placeholder }}
        </label>
        <div class="underline" [ngClass]="{ 'underline-show': showPanel, 'underline-hide': !showPanel }"></div>
    </div>
    <div class="hide" [ngClass]="{ show: showError && !option() }">
        <div>
            <small class="flex justify-start items-center text-red-600 mt-1">
                <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-[2px]">
                    <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#dc2626" stroke-width="2" stroke-linecap="round" />
                    <path d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7" stroke="#dc2626" stroke-width="2" stroke-linecap="round" />
                </svg>
                {{ mensajeError }}
            </small>
        </div>
    </div>
} @else {
    <div
        class="dropdown-container relative mt-6 rounded-t-md"
        [ngClass]="{
            'border-t-red-600 border-r-red-600 border-l-red-600 border': showError && !(option() ? option().length > 0 : false)
        }"
    >
        <p-multiselect
            [options]="sortedOptions"
            [(ngModel)]="option"
            [id]="id"
            (onPanelHide)="showPanel = false"
            (onPanelShow)="showPanel = true"
            [showClear]="limpiar"
            [optionLabel]="propiedad"
            appendTo="body"
            [filter]="filtrar"
            filterPlaceHolder="Ingrese búsqueda"
            [resetFilterOnHide]="true"
            [readonly]="readonly"
            class="h-12 w-full"
        >
            <ng-template pTemplate="dropdownicon">
                @if (!readonly) {
                    <img
                        src="assets/svg/arrow.svg"
                        alt="Arrow"
                        width="20"
                        [ngClass]="{ 'rotate-90': showPanel, '-rotate-90': !showPanel }"
                        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer transition-all duration-200 pointer-events-none"
                    />
                }
            </ng-template>
            <ng-template pTemplate="clearicon">
                <svg width="16" height="16" viewBox="0 0 24 24">
                    <path d="M14.5 9.5 9.5 14.5M9.5 9.5 14.5 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </ng-template>
            @if (descripcionLabel) {
                <ng-template let-item pTemplate="item">
                    <div class="w-full">
                        <p class="font-bold">{{ propiedad ? (item[propiedad] ?? item) : item }}</p>
                        @if (item[descripcionLabel]) {
                            <small class="pl-2">{{ item[descripcionLabel] }}</small>
                        }
                    </div>
                </ng-template>
            }
        </p-multiselect>
        <label class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none" [ngClass]="{ 'label-active': showPanel || (option() ? option().length > 0 : false) }">
            {{ etiqueta }}
        </label>
        <label
            class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none"
            [ngClass]="{
                'opacity-100': showPanel && !(option() ? option().length > 0 : false),
                'opacity-0': !showPanel || (option() ? option().length > 0 : false)
            }"
        >
            {{ placeholder }}
        </label>
        <div class="underline" [ngClass]="{ 'underline-show': showPanel, 'underline-hide': !showPanel }"></div>
    </div>
    <div class="hide" [ngClass]="{ show: showError && !(option() ? option().length > 0 : false) }">
        <div>
            <small class="flex justify-start items-center text-red-600 mt-1">
                <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-[2px]">
                    <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#dc2626" stroke-width="2" stroke-linecap="round" />
                    <path d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7" stroke="#dc2626" stroke-width="2" stroke-linecap="round" />
                </svg>
                {{ mensajeError }}
            </small>
        </div>
    </div>
}
